const BASE = process.env.VUE_APP_API_BASE_URL;

export const API = {
  // Auth
  LOGIN: `${BASE}/api/frontend/login`,
  LOGOUT: `${BASE}/api/frontend/logout`,

  // Transcriptions
  EDIT_PIECE: `${BASE}/api/frontend/editPiece`,
  DELETE_PIECE: `${BASE}/api/frontend/deletePiece`,
  DELETE_TRANSLATION: `${BASE}/api/frontend/deleteTranslation`,
  GET_TRANSCRIPTIONS_FOR_USER: `${BASE}/api/frontend/getTranscriptionsForUser`,
  GET_TRANSCRIPTIONS_FOR_GROUP: `${BASE}/api/frontend/getTranscriptionsForOneGroup`,
  GET_TRANSCRIPTIONS_OF_LIVE: `${BASE}/api/frontend/getTranscriptionsOfLive`,
  GET_TRANSLATIONS_FOR_USER: `${BASE}/api/frontend/getTranslationsForUser`,
  GET_ONE_TRANSCRIPTION: `${BASE}/api/frontend/getSummarizationOfTranscription`,

  // Uploads & processing
  TRANSCRIBE: `${BASE}/v1/transcribe_video_new`,
  TRANSLATE_FOR_TRANSCRIPTION: `${BASE}/v1/translateForTranscription`,
  TRANSLATE_SUBTITLES: `${BASE}/v1/translate_subtitles`,
  TRANSLATE_TEXT: `${BASE}/v1/translate_text`,
  TTS_GENERATE: `${BASE}/v1/tts/generate`,

  // Summaries
  SUMMARY_CREATE: `${BASE}/v1/summary/create`,
  SUMMARY_GET: `${BASE}/api/frontend/getSummarizationOfTranscription`,
  SUMMARY_UPDATE: `${BASE}/api/frontend/updateSummary`,
  SUMMARY_DELETE: `${BASE}/api/frontend/deleteSummary`,

  // Articles
  ARTICLE_GENERATE_TOPICS: `${BASE}/v1/generate/article/topics`,
  ARTICLE_GENERATE_FROM_TOPIC: `${BASE}/v1/generate/article/from-topic`,
  ARTICLES_GET_ALL: `${BASE}/api/frontend/getArticles`,
  ARTICLE_GET_ONE: (id) => `${BASE}/api/frontend/getArticle/${id}`,
  ARTICLE_UPDATE: (id) => `${BASE}/api/frontend/updateArticle/${id}`,
  ARTICLE_DELETE: (id) => `${BASE}/api/frontend/deleteArticle/${id}`,

  // Admin / data
  GET_USERS: `${BASE}/api/frontend/getUserOfCompany`,
  GET_GROUPS: `${BASE}/api/frontend/getGroups`,
  GET_COMPANIES: `${BASE}/api/frontend/getCompanies`,
  GET_PACKETS: `${BASE}/api/frontend/getPackets`,

  // Admin CRUD
  GET_ONE_USER: `${BASE}/api/frontend/getOneUser`,
  DELETE_USER: `${BASE}/api/frontend/deleteUser`,
  EDIT_USER: `${BASE}/api/frontend/editForEveryUser`,
  CREATE_USER: `${BASE}/api/frontend/registrationForUser`,
  CREATE_EDITOR: `${BASE}/api/frontend/registrationForEditor`,
  GET_ONE_COMPANY: `${BASE}/api/frontend/getOneCompany`,
  DELETE_COMPANY: `${BASE}/api/frontend/deleteCompany`,
  EDIT_COMPANY: `${BASE}/api/frontend/editCompany`,
  CREATE_COMPANY: `${BASE}/api/frontend/createCompany`,
  GET_ONE_GROUP: `${BASE}/api/frontend/getOneGroup`,
  DELETE_GROUP: `${BASE}/api/frontend/deleteGroup`,
  EDIT_GROUP: `${BASE}/api/frontend/editGroup`,
  CREATE_GROUP: `${BASE}/api/frontend/createGroup`,
  DELETE_PACKET: `${BASE}/api/frontend/deletePackets`,
  EDIT_PACKET_ITEM: `${BASE}/api/frontend/editPacketItem`,
  CREATE_PACKET: `${BASE}/api/frontend/createPacket`,
  DELETE_PACKET_ITEM: `${BASE}/api/frontend/deletePacketItems`,
  CREATE_PACKET_ITEM: `${BASE}/api/frontend/createPacketItem`,

  // Other views
  GET_ONE_TRANSCRIPTION: `${BASE}/api/frontend/getOneTranscription`,
  EDIT_TITLE: `${BASE}/api/frontend/editTitle`,
  GET_TRANSCRIPTIONS_FOR_GROUP_LAYOUT: `${BASE}/api/frontend/getTranscriptionsForGroup`,
  CHECK_CREATE_ARTICLE: (userId) => `${BASE}/api/frontend/checkCreateArticleForUser/${userId}`,
  ARTICLE_GENERATE_FROM_TRANSCRIPTION: `${BASE}/v1/generate/article/transcription`,
};
